
import Component from 'vue-class-component'
import moduleStore from './store/textToVideo';
import Vue from 'vue';
import PageState from './store/state';//使用最外层的state
import {
  notLoginMessage,
  notLoginErrorMessage,
  showConfirmDialog,
  toast
} from '@/utils/util'
import { judgeDeviceType } from "@/utils/device";
import RatioPopup from '../videoEditor/components/ratioPopup/ratioPopup';
import EffectPopup from '../videoEditor/components/effectPopup/effectPopup';
import StyleSpeedPopup from '../videoEditor/components/styleSpeedPopup/styleSpeedPopup';
import videoContentPopup from '../videoEditor/components/videoContentPopup/videoContentPopup';
import WordLimitPopup from '../videoEditor/components/wordLimitPopup/wordLimitPopup';
import SearchSpeaker from '../searchSpeaker/searchSpeaker';
import SmartTextEntry from './components/smartTextEntry.vue';
import ImageToStory from './components/imageToStory.vue';
import {getQueryString} from "@/utils/location";
import { containsLink } from '@/utils/validate';
import { _getSwitch, _getUserInfo, isNull, toAppLogin, toAppLoginParams, toAppMember, checkTextContent } from '@/utils/utils';
/**components**/
@Component({
  components: {
    RatioPopup,
    EffectPopup,
    StyleSpeedPopup,
    videoContentPopup,
    SearchSpeaker,
    WordLimitPopup,
    SmartTextEntry,
    ImageToStory,
  },
  watch: {
    // currSpeaker: {
    //   handler(newVal) {
    //     console.log('watch currSpeaker',newVal)
    //     this.currSpeakerStyle = this.$store.state.emotionListMap[newVal.speaker.split("@")[1]].emotionName;
    //   },
    //   deep: true
    // }
  },
  provide() {
    return {
      $textToVideo: {
        doLogin: this.doLogin
      }
    }
  }
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class textToVideoPage extends Vue implements IvuePage<PageState> {
  state = new PageState();
  self: Vue = this;
  smart_write = require('/public/images/video_editor/smart_write.png');

  writting = require('/public/images/video_editor/writting.png');
  magicIcon = require('/public/images/video_editor/magic.png');
  tipBg = require('/public/images/video_editor/tip_bg.png');
  closeIcon = require('/public/images/video_editor/icon_close_white.png');
  isTipsVisible = false;
  isApp = judgeDeviceType.isAPP;
  articleId = null; //当前文章id-查询时使用
  novelId = null; // 小说id-查询小说内容文本
  isNovel = false; // 是否查询小说内容文本
  copyResourceId = null; // 复制的来源resource.id
  copyResourceText = ''; // 复制的来源resource文本
  originCopyText = ''; // 复制的原始文案
  recreate = false; // 重新生成加参数
  text: string = '';
  get textLength() {
    return this.text.trim().length
  }
  articleTransform = false; //是否开启智能改写
  searchSpeakerVisible = false;
  styleList = [];
  ratioList = [];
  effectList = [];
  idx = 0; //当前选择的发音人
  currRatio = '4:3';
  currEffect = '静态';
  // currSpeaker = {headImage:'https://mobvoi-backend-public.ticwear.com/autoupload/voice-maker-h5/image/activity_1695870303243.jpeg'};
  currStyle = ''; //视频风格英文
  currStyleName = ''; // 视频风格中文
  currSpeed = '1.0';
  currSpeakerStyle = '默认'; //当前发音人风格
  currSpeakerStyleId = 0; //当前带发音人风格ID
  isSubmiting = false;
  ratioVisible = false;
  effectVisible = false;
  sspeedVisible = false; //style & speed
  speakerName = '魔云熙'; //默认查找的发音人
  speaker = ''
  freeWordLevelList = []; // 免费会员预设的字数选项
  normalLevelList = []; // 正常会员预设的字数选项
  vipInfo:any = {}; // 会员信息
  limitWordNum = 100; // 当前限制字数
  isWordLimitPopupVisible = false; // 是否显示字数限制弹窗
  singleLength = 1000; // 计算单位
  deductions = 0; // 扣减次数
  articleWordLimit = 0;
  articleOriginContent = ''; // 文章内容
  queryResource = ''; // 来源
  // 讲真是否显示
  isSwitch = false
  showTransform = false
  saveOriginContent = '' // 登录后存储文章内容
  get currSpeaker() {
    const _currSpeaker = this.$store.state.currSpeaker;
    //设置默认风格
    let defaultSpeaker = _currSpeaker.defaultSpeaker;
    this.currSpeakerStyleId = defaultSpeaker
      ? defaultSpeaker.speakerId
      : _currSpeaker.speakerEmotionCacheVOList[0].speakerId;
    const speakerEmotionCacheVOList = _currSpeaker.speakerEmotionCacheVOList
    if (speakerEmotionCacheVOList) {
      const styleIndx = speakerEmotionCacheVOList.findIndex(item => item.moodName === this.currSpeakerStyle)
      if (styleIndx === -1) {
        this.currSpeakerStyle = "默认"
      }
    }
    if(_currSpeaker.name.indexOf('|')) _currSpeaker.name = _currSpeaker.name.split('|')[0];  // 名称显示问题修复
    return _currSpeaker;
  }
  get placeHolder() {
    if (this.queryResource === 'WAIC') {
      return '输入或粘贴文案，最多不超过10句话，每句话建议15-20字且含有标点符号，总字数不能超过1000字。'
    }
    return `请输入 或 粘贴文案，当前设置最多${this.limitWordNum}字，可以点击输入框左下角下拉选择更多字数范围。`
  }
  async mounted() {
    this.isTipsVisible = localStorage.getItem('isWordTipsVisible') !== 'FALSE';

    (window as any).getAppClipBordContent = this.getAppClipBordContent;
    let speaker = decodeURIComponent(getQueryString('speaker')); //发音人mercury_yunxi_24k
    let speakerNameN = decodeURIComponent(getQueryString('speakerName')); //发音人中文名
    let styleEN = decodeURIComponent(getQueryString('styleEN')); //视频风格英文 anime
    const itemKey = decodeURIComponent(getQueryString('timestamp'));
    const articleId = decodeURIComponent(getQueryString('articleId'))
    let effect = decodeURIComponent(getQueryString('effect')); //视频效果
    let style = decodeURIComponent(getQueryString('style')); //视频风格
    let ratio = decodeURIComponent(getQueryString('ratio')); //视频比例
    let speed = decodeURIComponent(getQueryString('speakerSpeed')); //语速
    let speakerStyle = decodeURIComponent(getQueryString('speakerStyle')); //发音人风格
    let originContent = decodeURIComponent(getQueryString('originContent')); //发音人风格
    const recreate = decodeURIComponent(getQueryString('recreate'));
    if (!isNull(recreate)) {
      this.recreate = true;
    }
    if(itemKey!= 'null') {
      // 登录后回填数据
      const params = JSON.parse(localStorage.getItem('textToVideoParams'))
     
      if(params && params.timestamp == itemKey) {
        this.saveOriginContent = params.originContent || originContent;
        styleEN = params.styleEN || styleEN;
        ratio = params.ratio || ratio;
        effect = params.effect || effect;
        speakerNameN = params.speakerName || speakerNameN;
        speakerStyle = params.speakerStyle || speakerStyle;
        speed = params.speed || speed;
        this.queryResource = params.queryResource || '';
        this.novelId = params.novelId || '';
        if(params.speaker?.defaultSpeaker?.speaker) {
          this.$store.state.currSpeaker = params.speaker;
        }
      }
      // localStorage.removeItem('textToVideoParams');
    }
    const resource = decodeURIComponent(getQueryString('resource'));  //创作同款TEMPLATE
    if (!isNull(resource)) {
      this.queryResource = resource
    }
    try {
      const res:any = await _getUserInfo(this)
      if (res && res.originSource && this.isJZYCD(res.originSource)) {
        this.queryResource = res.originSource
      }
    } catch (error) {
      const code = error.code
      if (code === '150004') { // 登录过期
        localStorage.removeItem('ww_token')
      }
    }
   
    if (!isNull(articleId)) {
      this.articleId = articleId
    } else  {
      if (!isNull(speed)) {
        this.$store.state.currSpeed = speed && (+speed).toFixed(1);
      } else {
        this.$store.state.currSpeed = '1.0'; // 默认为1.2倍速
      }
      const novelId = decodeURIComponent(getQueryString('resourceId')); //小说id
      this.copyResourceId = getQueryString('copyResourceId'); //资源id
      if (this.queryResource === 'WAIC') {
        this.currStyle = 'Wen_cartoon'
        this.speakerName = '魔小葵'
        this.currRatio = '9:16'
      } else if (this.isJZYCD(this.queryResource)) {
        this.currStyle = 'Wen_guangyin'
        this.speakerName = '魔玲珑'
        this.currRatio = '4:3'
        this.$store.state.currSpeed = '1.3'
      }
      if (!isNull(novelId) && novelId !== '0' && resource.indexOf('TEMPLATE') === -1)  {
        this.novelId = novelId;
        this.isNovel = true;
      }

      if (!isNull(speakerNameN)) {
        this.speakerName = speakerNameN.split("|")[0];//参数可能是魔云熙|冷静
      }
      if (!isNull(speaker)) {
        this.speaker = speaker
      }
      if (!isNull(effect)) {
        this.currEffect = effect;
      }
      if (!isNull(style)) {
        this.currStyleName = style;
      }
      if (!isNull(styleEN)) {
        this.currStyle = styleEN;
      }
      if (!isNull(ratio)) {
        this.currRatio = ratio;
      }
      if (!isNull(speakerStyle)) {
        this.currSpeakerStyle = speakerStyle;
      }
      
      this.currSpeed = this.$store.state.currSpeed;
    }
    let isNetSwitch = true
    try {
      const res:any = await _getSwitch(this)
      isNetSwitch = res
    } catch (error) {
      console.log('error', error)
    }
    if (this.isJZYCD(this.queryResource) && !isNetSwitch) {
      this.isSwitch = false
      this.showTransform = true
    } else {
      this.isSwitch = true
    }
    this.state.self = this;
    if (!this.articleId) {
      this._getSpeakerEmotionList().then(() => {
        //查询默认的摩天轮的发音人数据(主要是找对应的风格及demo)
        this._getDefaultSpeakerFn();
      });
    }
     //获取所有风格
    this._getEffectListFn();
    this._getStylesFn(); //获取视频风格
    this._getRatioFn();
    this.$bus.$on('setStyle', this.setSpeakerStyle);
    this.$bus.$on('setSpeed', this.setSpeakerSpeed);
    window.addEventListener('storage', this.storageEvent);
  }
  hideTips() {
    localStorage.setItem('isWordTipsVisible', 'FALSE');
    this.isTipsVisible = false;
  }
  orginText: string
  // 获取小说详情
  getNovelText() {
    if (!this.novelId && !this.copyResourceId) return;
    const isFromCopy = !this.novelId
    const resourceId = this.novelId || this.copyResourceId;
    this.$http('getNovelDetail', { resourceId }).then((res) => {
      if (res.code === 200 && res.data) {
        const exciting = res.data.exciting;
        if (!exciting) return
        if (isFromCopy) {
          this.copyResourceText = exciting;
          return
        }
        const text = exciting.split('\\n').join('\n');
        const newText = this.rmDigitRow(this.rmSymbol(text))
        this.orginText = newText;
        this.setText(newText, true);
      }
    })
  }
  /**
   * 将单行纯数字改为空
   * @param text
   */
  rmDigitRow(text) {
    const list = text.split('\n')
    let str = ''
    list.forEach((item, index) => {
      const newItem = item.replace(/\s/g, '')
      if (newItem && newItem.match(/^\d+$|^\d+.$|^\d+、$/)&&newItem.length < 3) {
        str += '\n'
      } else {
        if (index === list.length - 1) {
          str += item
        } else {
          str += item + '\n'
        }
      }
    })
    return str
  }
  /**
   * 
   * @param text
   */
  rmSymbol(text) {
    if (!text) return ''
    const reg = /「|」|\[|\]|"|“|'|'|【|】|<|>/g
    text = text.replace(reg, '')
    return text
  }
  /**
   * 是否是讲真来源
   */
  isJZYCD(resource: string) {
    const str = resource.toLocaleUpperCase();
    return str.indexOf('JZ') !== -1;
  }
  /**
   * 获取详情
   * @param articleId
   */
  getArticleDetail() {
    if (isNull(this.articleId)) {
      this.articleId = null
      this._getMemberInfo();
      // console.log
      if (this.queryResource.indexOf('TEMPLATE') === -1 && !this.isJZYCD(this.queryResource)) {
        this._getLastArticleInfo()
      }
      
      return
    }
    this.$http('articleDetail', {articleId: this.articleId}).then((res) => {
      if (res.code === 200 && res.data) {
        if(res.data.resourceType === 1) this.novelId = res.data.resourceId; // 小说推文
        const extend = res.data.extend;
        if (extend && extend.imageUrls && extend.imageUrls[0]) { // 图生文 重新生成
          if(!this.isDouyin) this.activeTabId = 'image';
          this.imageUrls = extend.imageUrls;
        }
        const extendVO = res.data.extendVO;
        this.articleOriginContent =  this.rmSymbol(extendVO.originContent)
        this.isPaste = true
        this.orginText = this.articleOriginContent
        this.articleWordLimit = res.data.wordLimit
        this.setLastConfigInfo(extendVO)
        
      }
    }).finally(() => {
      this.articleId = null
      this._getSpeakerEmotionList().then(() => {
        //查询默认的摩天轮的发音人数据(主要是找对应的风格及demo)
        this._getDefaultSpeakerFn();
      });
    })
  }
  /**
   * 获取最近一篇文章信息（主要取里面的配置信息）
   */
  _getLastArticleInfo() {
    const ww_token = localStorage.getItem('ww_token');
    if(!ww_token) return Promise.resolve(false);
    this.$http('getLastArticleInfo', {resourceTypes: 'ONE_CLICK,NOVEL'}).then((res) =>{
      if (res.code === 200 && res.data) {
        this.setLastConfigInfo(res.data.extendVO)
      }
    })
  }
  /**
   * 设置配置信息
   * @param extendVO
   */
  setLastConfigInfo(extendVO) {
    if (this.queryResource !== 'WAIC') {
      this.currEffect = extendVO.effectCode;
      this.currRatio = extendVO.scaleCode;
      if (extendVO.speakerName) {
        this.speakerName = extendVO.speakerName.split("|")[0];//参数可能是魔云熙|冷静
      }
      if (extendVO.speaker) {
        this.speaker = extendVO.speaker
      }
      this.currSpeakerStyle = extendVO.speakerStyle;
      this.$store.state.currSpeed = extendVO.speechSpeed;
      this.currSpeed = this.$store.state.currSpeed;
    }
    
    this.articleTransform = extendVO.articleTransform === 1
    let _style = this.queryResource === 'WAIC' ? 'Wen_cartoon' : extendVO.styleCode
    const styleInfo = this.styleList.find(item => item.nameEN === _style)
    if (styleInfo) {
      this.currStyle = styleInfo.nameEN
      this.currStyleName = styleInfo.name
      this.$nextTick(() => {
        const _styleInfo = this.styleList.find(item => item.nameEN === this.currStyle)
        if (_styleInfo) {
          const itemDom = document.getElementById(this.currStyle + '_item')
          const rect = itemDom.getClientRects()[0]
          const listWrapper = this.$refs.styleListRef as any;
          listWrapper.scrollLeft = rect.left - 74
          this.changeVideoStyle(_styleInfo)
        }
        
      })
      
    }
    if (!isNull(this.articleId)) {
      this._getMemberInfo('detail');
    } else {
      this._getMemberInfo();
    }
    this._getDefaultSpeakerFn();
  }
  destroy() {
    window.removeEventListener('storage', this.storageEvent);
  }
  storageEvent(event: StorageEvent) {
    const { key, newValue } = event;
    if(key === 'currSpeaker' && newValue) {
      const currSpeaker = JSON.parse(newValue);
      // 风格图片
      const speakerEmotionCacheVOList = currSpeaker?.speakerEmotionCacheVOList || [];
      speakerEmotionCacheVOList.map(item => {
        const moodName = item.speaker.split('@')[1] || 'default2';
        item.moodImg = item.moodImg || this.$store.state.emotionListMap[moodName]?.imageUrl
      })
      this.speakerName = currSpeaker.name
      this.$store.state.currSpeaker = currSpeaker;
      localStorage.removeItem('currSpeaker');
    } else if(key === 'doLogin' && newValue === 'true') {
      this.doLogin();
      localStorage.removeItem('doLogin');
    }
  }
  /**
   * 获取字数限制
   */
  _getWordLimitInfo(type?:string) {
    this.$http('getWordLimit').then((res) => {
      if (res.data) {
        const { freeVipMaxLimit, normalVipLimit, freeWordLevelList, normalLevelList, singleLength, lastWord} = res.data
        this.freeWordLevelList = freeWordLevelList
        this.normalLevelList = normalLevelList
        let _levelList = []
        if (this.vipInfo.vipType === 0 || this.vipInfo.vipType === undefined) {
          this.limitWordNum = freeWordLevelList[0]
          _levelList = freeWordLevelList
        } else if (this.vipInfo.vipType === 1) {
          this.limitWordNum = normalLevelList[0]
          _levelList = normalLevelList
        }
        console.log('_getWordLimitInfo', this.articleWordLimit)
       
        if (type) {
          if (!isNull(this.articleWordLimit)) {
            this.limitWordNum = this.articleWordLimit
          } else {
            const contentLength = this.articleOriginContent.length

            if (contentLength >= _levelList[_levelList.length - 1]) {
              this.limitWordNum = _levelList[_levelList.length - 1]
            } else if (contentLength <= _levelList[0]) {
              this.limitWordNum = _levelList[0]
            } else {
              for (let i = 0; i < _levelList.length; i++) {
                if (contentLength === _levelList[i]) {
                  this.limitWordNum = _levelList[i]
                  break
                } else if (contentLength > _levelList[i] && contentLength <= _levelList[i + 1]) {
                  this.limitWordNum = _levelList[i + 1]
                  break
                }
              }
            }
          }
          this.setText(this.articleOriginContent, true)
        } else {
          if (!isNull(this.articleWordLimit)) {
            this.limitWordNum = this.articleWordLimit
          } else if (!isNull(lastWord)) {
            this.limitWordNum = lastWord
          }
        }
        if (this.saveOriginContent && this.saveOriginContent != 'null') {
         this.setText(this.saveOriginContent)
        }
        
        this.singleLength = singleLength
      }
      console.log('getWordLimitInfo', res)
    }).finally(() => {
      // 获取小说文本
      this.getNovelText();
    })
  }
  /**
   * 获取会员权益
   */
  _getMemberInfo(type?: string) {
    this.getVipInfo()
      .then((res) => {
        if (res) {
          this.vipInfo = res
          let articleWordLimit = localStorage.getItem('articleWordLimit');
          if (!isNull(articleWordLimit) && this.vipInfo.vipType === 1) {
            this.articleWordLimit = Number(articleWordLimit)
          }
        }
      }).finally(() => {
        this._getWordLimitInfo(type);
      })
  }
  /**
   * 展示字数显示popup
   */
  showWordPopup() {
    this.isWordLimitPopupVisible = true
  }
  onAnimationend() {
    console.log('onAnimationend', (this.$refs.textLengthRef as any).classList);
    (this.$refs.textLengthRef as any).classList.remove('word-num-anim')
  }
  isInput = false
  preText = ''
  onFocus() {
    this.preText = this.text
  }
  onInput() {
    this.isInput = true
  }
  onBlur() {
    if (this.isInput && this.preText !== this.text) {
      this.orginText = this.text
    }
    this.setAiText(this.text);  // 失去焦点时获取文本内容，进行智能文案生成
  }
  setAiText(content) {
    const tab = this.tabList.find(item => item.id === this.activeTabId);
    tab.aiText = content;
  }
  /**
   * 确认字体
   * @param wordNumber
   */
  confrimLimitWord(wordNumber) {
    this.limitWordNum = wordNumber
    if (this.isNovel || this.isPaste) {
      this.setText(this.orginText, true)
    } else {
      this.setText(this.text, true)
    }
    localStorage.setItem('articleWordLimit', this.limitWordNum + '')
    this.closeLimitPopup()
  }
  closeLimitPopup() {
    this.isWordLimitPopupVisible = false
  }
  clear() {
    this.text = '';
    this.setAiText('');
  }
  getAppClipBordContent(message: string) {
    message = decodeURI(message) || '';
    if (!message) return
    this.originCopyText = message
    message = message + this.text
    message = this.rmSymbol(message)
    this.orginText = message
    this.isPaste = true
    this.setText(message)
  }
  async pasteTxt() {
    if (this.isSubmiting) {
      return toast('正在生成中，请稍后再试');
    }
    if (this.isApp) {
      let getClipBordContent: any = (<any>window).getClipBordContent;
      getClipBordContent.postMessage('');
    } else {
      // toast("请点击输入框，长按粘贴内容")
      try {
        let cptext = await navigator.clipboard.readText();
        this.originCopyText = cptext
        cptext = cptext + this.text
        cptext = this.rmSymbol(cptext)
        this.orginText = cptext
        this.isPaste = true
        this.setText(cptext)
      } catch (error) {
        toast("请点击输入框，长按粘贴内容");
        console.log('粘贴出错:', error);
      }
    }
  }
  isPaste = false
  onPasteText(e) {
    if (this.isSubmiting) {
      return toast('正在生成中，请稍后再试');
    }
    try {
      e.preventDefault();  // 禁止默认事件，即粘贴的内容不放到文本框中
       // 获取剪贴板数据
      const clipboardData = e.clipboardData || window.clipboardData;
      const pastedData = clipboardData.getData('text');
      this.originCopyText = pastedData
      let result = this.text + pastedData.replace(/[「」]/g, ''); // 粘贴的内容进行过滤
      const isMax = result.length > this.limitWordNum;
      result = this.rmSymbol(result)
      this.orginText = result
      if (isMax) {
        (this.$refs.textLengthRef as any).classList.add('word-num-anim');
        if (this.vipInfo.vipType === 0) {
          toast(`体验会员最多输入${this.limitWordNum}字超出部分自动截断，你可以点击输入框左下角设置更大的字数范围`, 'top', 4000);
        } else {
          toast(`最多输入${this.limitWordNum}字超出部分自动截断，你可以点击输入框左下角设置更大的字数范围`, 'top', 4000);
        }
        result = result.substring(0, this.limitWordNum);
      }
      this.isPaste = true
      this.text = result; // 设置文本框为过滤后的内容
    } catch (error) {
      toast("请点击输入框，长按粘贴内容");
    }
   
  }
  setText(text, isBackfill = false) {
    text = text.trim()
    if (text.length > this.limitWordNum) {
      (this.$refs.textLengthRef as any).classList.add('word-num-anim');
      if (this.vipInfo.vipType === 0) {
        toast(`体验会员最多输入${this.limitWordNum}字超出部分自动截断，你可以点击输入框左下角设置更大的字数范围`, 'top', 4000);
      } else {
        toast(`最多输入${this.limitWordNum}字超出部分自动截断，你可以点击输入框左下角设置更大的字数范围`, 'top', 4000);
      }
     
      text = text.substring(0, this.limitWordNum);
    }
    this.text = text;
    if (isBackfill) this.setAiText(text); // 小说推文or重新生成回填，开始进行智能文案生成
  }
  changeVideoStyle(item) {
    this.currStyle = item.nameEN
    this.currStyleName = item.name
    if (item.ratioList) {
      this.ratioList = item.ratioList
      this.filterRatio()
    }
  }
  doClickLock() {
    showConfirmDialog({
      message: '成为会员解锁视频风格',
      confirmButtonText: '前往了解',
    }).then(() => {
      const ww_token = localStorage.getItem('ww_token');
      if(!ww_token) {
        this.doLogin();
        return;
      }
      if (this.isApp) {
        toAppMember()
      } else {
        this.$navigateTo({
          url: '/mine-package/pages/recharge-vip/recharge-vip'
        })
      }
    })
  }
  changeTransform() {
    // toast('暂不支持关闭改写！');
    this.articleTransform = !this.articleTransform
  }
  filterRatio() {
    const _filterRaito = this.ratioList.find(item => item.ratio === this.currRatio)
    if (!_filterRaito) {
      const info = this.ratioList.find(item => item.ratio === '4:3')
      if (info) {
        this.currRatio = '4:3'
      } else {
        this.currRatio = this.ratioList[0].ratio
      }
    }
    
  }
  showPopup(type) {
    switch (type) {
      case 'ratio':
        this.ratioVisible = true;
        break;
      case 'effect':
        this.effectVisible = true;
        break;
      case 'sspeed':
        this.sspeedVisible = true;
        break;
      default:
        break;
    }
  }
  setCurrRatio(e) {
    this.currRatio = e;
  }
  setCurrEffect(e) {
    this.currEffect = e;
  }

  //点击了文生视频发音人后面的图标
  // toSearchSpeaker(){
  //   console.log('去查找发音人',this.$store.state.emotionListMap,this,this.currSpeaker.speakerEmotionCacheVOList)
  //   if(!this.$store.state.emotionListMap){
  //     return;
  //   }
  //   //默认取当前发音人第一个风格的id(发音人下有风格speakerEmotionCacheVOList)
  //   if(!this.currSpeaker.speakerEmotionCacheVOList){
  //     console.log('---currSpeaker没有风格相关信息',this.currSpeaker.name)
  //   }
  //   let speakerName = this.currSpeaker.name.split('@')[0];//本体发音人
  //   this.$router.push({path:'/searchSpeaker',query:{selectSpeakerName:speakerName}})
  // }
  showSpeakerPop() {
    // 存储已经输入的参数
    const itemKey = new Date().getTime() + '';
    const params: any = {
      originContent: this.orginText || this.text,
      styleEN: this.currStyle,
      ratio: this.currRatio,
      effect: this.currEffect,
      speakerName: this.currSpeaker.name,
      speaker: {
        headerImage: this.currSpeaker.headerImage,
        name: this.currSpeaker.name,
        code: this.currSpeaker.code,
        defaultSpeaker: { speaker: this.currSpeaker?.defaultSpeaker?.speaker }
      },
      speakerStyle: this.currSpeakerStyle,
      speed: this.currSpeed,
      timestamp: itemKey,
      novelId: this.novelId,
      queryResource: this.queryResource
    };
    localStorage.setItem('textToVideoParams', JSON.stringify(params))
    // console.log('去查找发音人',this.$store.state.emotionListMap,this,this.currSpeaker.speakerEmotionCacheVOList)
    // this.searchSpeakerVisible = true;
    const linkUrl = window.location.origin + '/#/searchSpeaker?speakerId=' + this.currSpeaker?.speakerId + '&open=true';
    if (this.isApp) {
      let switchWebviewUrl = (<any>window).switchWebviewUrl;
      switchWebviewUrl.postMessage(linkUrl)
    } else {
      this.$navigateTo({
        url: '/pages/webview/webview?url=' + encodeURIComponent(linkUrl),
      })
    }
  }
  _getSpeakerEmotionList() {
    return new Promise((resolve, reject) => {
      let vm = this;
      return this.$http('getSpeakerEmotionList', {})
        .then(res => {
          if (res.code == 200) {
            vm.$store.state.emotionListMap = (res.data || []).reduce((target: any, item: any) => {
              target[item.emotion] = { imageUrl: item.imageUrl, emotionName: item.emotionName };
              return target;
            }, {});
            console.log('---vm.$store.state.emotionListMap', vm.$store.state.emotionListMap);
            resolve(res);
          } else {
            // this
            reject(res);
          }
        })
        .catch(err => {
          console.log(err);
          reject(err);
        });
    });
  }
  _getStylesFn() {
    let vm = this;
    return this.$http('getStyleList', {pageSize: 9999}).then(res => {
      if (res.code == 200) {
        vm.styleList = res.data.results;
        const styleInfo = vm.styleList.find(item => item.nameEN === this.currStyle)
        if (styleInfo) {
          this.currStyleName = styleInfo.name
        } else {
          this.currStyle = vm.styleList[0].nameEN || '默认'
          this.currStyleName = vm.styleList[0].name || '默认'
        }
        if (this.styleList[0].ratioList) {
          this.ratioList = this.styleList[0].ratioList
          this.filterRatio()
        }
        this.getArticleDetail()
      }
    });
  }
  _getRatioFn() {
    let vm = this;
    this.$http('getRatioList').then(res => {
      if (res.code === 200) {
        vm.ratioList = res.data;
      }
    });
  }
  _getEffectListFn() {
    this.$http('getEffectList').then(res => {
      if (res.code === 200) {
        this.effectList = res.data;
        const effectInfo = res.data.find(item => item.effect === '静态') || res.data[0]
        if (effectInfo) {
          this.currEffect = effectInfo.effect
        }
      }
    });
  }
  _getDefaultSpeakerFn() {
    let queryParam: any = {
      pageNum: 1,
      pageSize: 1000,
      keyword: this.speakerName,
    };
    let vm = this;
    this.$http('getDefaultSpeaker', queryParam).then(res => {
      if (res.code === 200) {
        let defaultSpeaker = res.data.results[0]; //todo
        if (this.isJZYCD(this.queryResource)) {
          defaultSpeaker = res.data.results.find(item => item.name === '魔玲珑')
        }
        
        if (this.speaker) {
          res.data.results.forEach((speakerInfo) => {
            if (speakerInfo.speaker === this.speaker) {
              defaultSpeaker = {...speakerInfo, ...speakerInfo.speakerEmotionCacheVOList[0]};
            }
            else if (speakerInfo.speakerEmotionCacheVOList && speakerInfo.speakerEmotionCacheVOList.length) {
              const info = speakerInfo.speakerEmotionCacheVOList.find((item) => item.speaker === this.speaker)
              if (info) {
                defaultSpeaker = {...speakerInfo, ...info}
                // 风格丢失问题修复
                const currSpeakerStyle = defaultSpeaker.name.split('|')[1];
                if(currSpeakerStyle) this.currSpeakerStyle = currSpeakerStyle;
              }
            }
          })
        }
        //给当前发音人风格赋值-moodImg-风格图片(风格名称可以取发音人name|后面的值)
        if (!defaultSpeaker) return;

        defaultSpeaker.speakerEmotionCacheVOList &&
          defaultSpeaker.speakerEmotionCacheVOList.forEach(item => {
            let moodName = item.speaker.split('@')[1];
            item.moodName = item.name.split('|')[1] || moodName;
            if (moodName &&  this.$store.state.emotionListMap[moodName]) {
              item.moodImg = this.$store.state.emotionListMap[moodName].imageUrl;
            } else {
              // item.moodImg = defaultSpeaker.headerImage;//test -todo换成默认
              //使用默认头像
              item.moodImg = this.$store.state.emotionListMap['default2'].imageUrl;
            }
          });
        //-若没有风格-将风格中的第一个发音人作为默认发音人数据
        if (
          vm.currSpeakerStyle == 'null' ||
          !vm.currSpeakerStyle ||
          vm.currSpeakerStyle == '默认'
        ) {
          defaultSpeaker.defaultSpeaker = defaultSpeaker.speakerEmotionCacheVOList[0];
        } else {
          //进入页面时传了风格 则将对应风格的发音人作为默认发音人数据
          defaultSpeaker.defaultSpeaker = defaultSpeaker.speakerEmotionCacheVOList.find(item => {
            return item.name.split('|')[1] == vm.currSpeakerStyle;
          });
          console.log('-----进入页面textTovideo时传了风格 ', defaultSpeaker.defaultSpeaker);
        }
        vm.currSpeakerStyleId = defaultSpeaker.defaultSpeaker.speakerId; //带风格的发音人id
        this.$store.state.currSpeaker = defaultSpeaker;
        console.log('-----当前textTovideo默认发音人ID', vm.currSpeakerStyleId);
      }
    });
  }
  comfirmStyleSpeed(selectedStyleValue, selectedStyleName, selectedSpeedValue) {
    console.log('----确认啦', selectedStyleValue, selectedSpeedValue);
    this.setSpeakerStyle(selectedStyleValue, selectedStyleName);
    this.setSpeakerSpeed(selectedSpeedValue);
    this.sspeedVisible = false;
  }
  //保存发音人风格(selectedStyleValue = speakerId,selectedStyleName)
  setSpeakerStyle(selectedStyleValue, selectedStyleName) {
    console.log('---textToview修改风格', selectedStyleValue, selectedStyleName);
    this.currSpeakerStyle = selectedStyleName || '默认';
    this.currSpeakerStyleId = selectedStyleValue;
  }
  setSpeakerSpeed(selectedSpeedValue) {
    this.currSpeed = selectedSpeedValue;
    this.$store.state.currSpeed = selectedSpeedValue;
  }
  //取消选择发音人
  closeSpeakerPopup() {
    this.searchSpeakerVisible = false;
  }

  // 跳转登录，存储数据
  doLogin() {
    const itemKey = new Date().getTime() + '';
    const params: any = {
      originContent: this.orginText || this.text,
      styleEN: this.currStyle,
      ratio: this.currRatio,
      effect: this.currEffect,
      speakerName: this.currSpeaker.name,
      speaker: {
        headerImage: this.currSpeaker.headerImage,
        name: this.currSpeaker.name,
        code: this.currSpeaker.code,
        defaultSpeaker: { speaker: this.currSpeaker?.defaultSpeaker?.speaker }
      },
      speakerStyle: this.currSpeakerStyle,
      speed: this.currSpeed,
      timestamp: itemKey,
      novelId: this.novelId,
      queryResource: this.queryResource
    };
    localStorage.setItem('textToVideoParams', JSON.stringify(params))
    // const redirectUrl = `${window.location.origin}/#/textToVideo?timestamp=${itemKey}`
    // const redirect = `/pages/webview/webview?url=${ encodeURIComponent(redirectUrl)}`
    if (this.isApp) {
      toAppLoginParams({
        timestamp: itemKey
      })
    } else {
      this.$redirectTo({
        url: '/pages/login/login?from=textToVideo&timestamp='+itemKey
      })
    }
  }
  // 判断未登录先跳转登录
  doCreateSubmit() {
    const ww_token = localStorage.getItem('ww_token');
    if(!ww_token) {
      this.doLogin();
      return;
    }
    this.createSubmit();
  }
  loading = false
  //一键生成视频
  createSubmit() {
    if (this.textLength === 0) {
      toast('请输入内容');
      return;
    }
    if (containsLink(this.text)) {
      toast('不支持包含链接的文案');
      return;
    }
    if(!new RegExp("[\\u4E00-\\u9FFF]+","g").test(this.text)) {
      toast('请重新输入有效内容');
      return;
    }
    if(this.smartTextRef){ // 智能文案参数
      const generateStatus = this.smartTextRef.generateStatus;
      if (generateStatus === 'loading') {
        toast('智能文案生成中，请稍后');
        return;
      }
      if (generateStatus === 'empty') {
        toast('文案存在风险，请重新输入');
        return;
      }
    }
    this.loading = true
    this.getVipInfo()
      .then((res) => {
        if (res) {
          if (this.textLength <= this.singleLength) {
            this.deductions = 1
          } else {
            this.deductions = Math.ceil(this.textLength / this.singleLength)
          }
          // 打开视频清单弹窗
          this.showVideoContentPopup()
        }
      }).finally(() => {
        this.loading = false
      })
  }

  getVipInfo() {
    const ww_token = localStorage.getItem('ww_token');
    if(!ww_token) return Promise.resolve(false);
    return this.$http('queryMemberLeftRight')
      .then((res) => {
        const { code, data, message } = res
        if (code === 200) {
          // 会员权益
          this.isVip = data.vipRightsVO.isVip
          // 生成次数权益
          this.totalGenerateCount = data.totalRightsCountVO.totalCount
          this.leftGenerateCount = data.totalRightsCountVO.leftCount
          return data;
        } else {
          console.error(message)
          return false;
        }
      }).catch(err => {
        console.log('getVipInfo', err)
      })
  }
  /****************************** 视频清单 ******************************/

  // 判断用户是/否是会员
  isVip = false
  // 总生成次数
  totalGenerateCount = 0
  // 剩余生成次数
  leftGenerateCount = 0

  // 控制视频清单弹窗显/隐
  isVideoContentPopupVisible = false

  /** 展示视频清单弹窗 */
  showVideoContentPopup() {
    this.isVideoContentPopupVisible= true
  }

  /** 隐藏视频清单弹窗 */
  hideVideoContentPopup() {
    this.isVideoContentPopupVisible = false
  }
  /**
   * 判断是否符合规则的发音人
   */
  isRuleSpeaker() {
    const speakerEmotionCacheVOList = this.currSpeaker.speakerEmotionCacheVOList
    if (!speakerEmotionCacheVOList || !speakerEmotionCacheVOList.length) {
      toast('该发音人模型不存在')
      return false
    }
    const index = speakerEmotionCacheVOList.findIndex(item => item.speaker === this.currSpeaker?.defaultSpeaker?.speaker)
    if (index === -1) {
        this.currSpeaker.defaultSpeaker.speaker = speakerEmotionCacheVOList[0].speaker
        return true
    }
    return true
  }

  /** 确认生成视频 */
  async confirmGenerateVideo() {
    if (this.isSubmiting) return
    if (isNull(this.currStyle)) {
      toast('视频风格不能为空');
      return
    }
    if (isNull(this.currRatio)) {
      toast('视频比例不能为空');
      return
    }
    if (isNull(this.currEffect)) {
      toast('视频特效不能为空');
      return
    }
    if (isNull(this.currSpeaker) || isNull(this.currSpeaker?.defaultSpeaker?.speaker)) {
      toast('发音人不能为空');
      return
    }
    if (!this.isRuleSpeaker()) {
      return
    }
    if (isNull(this.currSpeakerStyle)) {
      toast('发音人风格不能为空');
      return
    }
    if (isNull(this.currSpeed)) {
      toast('发音人语速不能为空');
      return
    }
    const params: any = {
      originContent: this.text.trim(),
      // articleTransform: this.articleTransform ? 1 : 0,
      styleCode: this.currStyle,
      scaleCode: this.currRatio, //比例
      effectCode: this.currEffect,
      speaker: this.currSpeaker?.defaultSpeaker?.speaker,
      speakerStyle: this.currSpeakerStyle,
      speechSpeed: this.currSpeed,
      voiceType: this.$store.state.currSpeaker.voiceType || 0,
      platform: this.isApp ? 'APP' : judgeDeviceType.isMobile ? 'MINI' : 'UNKNOWN',
      resourceType: 'ONE_CLICK',
      wordLimit: this.limitWordNum,
      recreate: this.recreate,
    };

    // 检测文案风险
    const checkRes = await checkTextContent(this, params.originContent);
    if (checkRes) return;

    if (this.articleId) {
      params.articleId = this.articleId;
    }
    if (this.novelId) {
      params.resourceId = this.novelId;
      params.resourceType = 'NOVEL';
    } else if (this.originCopyText && this.copyResourceId && this.copyResourceText.indexOf(this.originCopyText) !== -1) {
      params.resourceId = this.copyResourceId;
      params.resourceType = 'NOVEL';
    }
    if(this.smartTextRef){ // 智能文案参数
      const smartTextParams = this.smartTextRef.smartTextParams || {}
      Object.assign(params, smartTextParams);
    } else {
      params.articleTransform = this.articleTransform ? 1 : 0;
    }

    if (this.activeTabId === 'image' && this.imageToStoryRef) { // 图生文把要图片带过去
      params.extend = {
        imageUrls: this.imageToStoryRef.imageUrls
      }
    }
    this.isSubmiting = true;
    this.$http('submitCreate', params).then(res => {
      console.log('-----一键生成视频re', res);
      this.isSubmiting = false;
      if (res.code == 200) {
        this.isSubmiting = true;
        //跳转到下一个状态页面
        if (this.isApp) {
          const switchToArticleCreating: any = (<any>window).switchToArticleCreating
          switchToArticleCreating.postMessage(res.data.articleId + '')
        } else {
          this.$redirectTo({
            url: `/baohuo-package/pages/audio-creating/audio-creating?articleId=${res.data.articleId}`
          });
        }
      } else if (res.message == notLoginMessage) {
        this.doLogin();
      } else {
        // toast('生成错误！');
        toast(res.message);
      }
    }).catch(err => {
      if (err?.response?.data?.message === notLoginErrorMessage) {
        this.doLogin();
      }
    })
  }

  imageUrls = null;
  isDouyin = getQueryString('platform') === 'tt';
  get isShowImageToStory() { // 是否显示图片转故事
    return !this.isDouyin && (this.imageUrls || this.queryResource === 'WAIC');
  }
  tabList = [ // 生成文案的tab
    {
      id: 'text',
      name: '输入文案',
      text: '',
      aiText: '',
    }, {
      id: 'image',
      name: '输入图片',
      text: '',
      aiText: '',
    }
  ];
  activeTabId = 'text';
  changeTab(tab) {
    if (tab.id === this.activeTabId) return;
    const oldText = this.text;
    this.tabList.forEach(item => {
      if (item.id === this.activeTabId) {
        // 旧tab项的输入框内容存储
        item.text = oldText;
      } else if (item.id === tab.id) {
        // 新tab项的输入框内容赋值
        this.text = item.text;
      }
    })
    this.activeTabId = tab.id;
  }
  // 设置图生文的内容
  setStoryText(text) {
    if(this.activeTabId === 'image') {
      this.setText(text, true);
    } else {
      const tab = this.tabList.find(item => item.id === 'image');
      tab.text = text;
      tab.aiText = text;
    }
  }
  get imageToStoryRef() {
    return (this.$refs.imageToStoryRef || null) as any
  }
  get smartTextRef() {
    const refArr = this.$refs['smartTextRef' + this.activeTabId] || []
    return (refArr[0] || null) as any
  }
}
